<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <button class="modal-close-button" @click="$emit('close')">
          <FontAwesomeIcon :icon="['fas', 'window-close']" />
        </button>
        <div class="modal-body">
          <img :src="getImg(book.cover_url)" />
        </div>
        <ul>
          <li>書籍名：{{ book.title }}</li>
          <li>著者名：{{ book.author }}</li>
          <li>出版社：{{ book.publisher }}</li>
          <li>ISBN：{{ book.isbn }}</li>
          <li>出版日：{{ book.publish_date }}</li>
          <li>
            リンク：
            <a :href="book.amazon_url" target="_blank">
              <img :src="amazonImg" width="60" height="15%" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faWindowClose } from '@fortawesome/free-solid-svg-icons'
import { onMounted } from '@vue/composition-api'
import books from '@/assets/book.json'

const baseUrl = 'https://est.d-book.mobi/cloudbookshelf'

export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    bookId: Number,
  },
  setup(props) {
    library.add(faWindowClose)

    const book = ref({})
    onMounted(async () => {
      const _books = books
      book.value = _books.find(book => book.id === props.bookId)
    })

    const getImg = url => baseUrl + '/image' + url

    const amazonImg = require('@/assets/images/amazon.png')

    return {
      book,
      getImg,
      amazonImg,
    }
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-body {
  margin: 20px 0;
}

.modal-close-button {
  border: none;
  outline: none;
  background: transparent;
  float: right;
}
</style>
